/**
 * ==========================================================================
 *  FeedbackDemo.jsx — Test-Seite fuers Feedback-Widget
 * ==========================================================================
 *  Schlichte Hintergrund-Seite, die das FeedbackWidget direkt einbettet.
 *  Damit kann Hendrik das Widget ohne Iframe-Setup ausprobieren, bevor
 *  Niko es in app.pflege-dschungel.de integriert.
 *
 *  Aufruf: https://beratungs-cockpit.de/feedback-demo
 * ==========================================================================
 */

import React from 'react';
import FeedbackWidget from './FeedbackWidget';

export default function FeedbackDemo() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: '40px 24px',
    }}>
      <div style={{
        maxWidth: 720,
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: 16,
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
        padding: 36,
      }}>
        <div style={{
          display: 'inline-block',
          padding: '4px 10px',
          backgroundColor: '#fef3c7',
          color: '#92400e',
          fontSize: 11,
          fontWeight: 700,
          borderRadius: 4,
          textTransform: 'uppercase',
          letterSpacing: 1,
          marginBottom: 16,
        }}>
          Demo-Seite
        </div>
        <h1 style={{
          fontSize: 28,
          fontWeight: 700,
          color: '#1f2937',
          margin: '0 0 12px',
        }}>
          Feedback-Widget — Vorschau
        </h1>
        <p style={{ fontSize: 15, color: '#4b5563', lineHeight: 1.6, margin: '0 0 16px' }}>
          Das Widget unten rechts simuliert hier, wie es später auf
          <strong> app.pflege-dschungel.de</strong> aussieht. Klicke auf den
          brombeer-farbenen Floating-Button unten rechts, um es zu öffnen.
        </p>
        <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.6, margin: '0 0 24px' }}>
          Du kannst eine Test-Anfrage abschicken — sie landet in der Datenbank
          und du bekommst eine Notification-Mail an deine
          hendrik.dohmeyer@gmail.com-Adresse. Im Berater-Cockpit wirst du
          die Anfragen ab Häppchen C im Pflege-Cockpit-Tab unter „Anfragen"
          sehen können.
        </p>
        <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '24px 0' }} />
        <h2 style={{ fontSize: 16, fontWeight: 600, color: '#374151', margin: '0 0 8px' }}>
          So testet du das Widget:
        </h2>
        <ol style={{ fontSize: 14, color: '#4b5563', lineHeight: 1.8, paddingLeft: 20, margin: 0 }}>
          <li>Floating-Button unten rechts anklicken — Panel klappt auf.</li>
          <li>Einen Bereich auswählen (z.B. „Pflegegrad-Rechner").</li>
          <li>Test-Nachricht + Test-Email + ggf. Telefonnummer eintragen.</li>
          <li>„Nachricht senden" → Erfolgsmeldung erscheint.</li>
          <li>Mail in deinem Gmail-Postfach prüfen.</li>
          <li>Tutorials-Bereich unten aufklappen — vier Karten verlinken auf die PDFs.</li>
        </ol>
      </div>

      <FeedbackWidget />
    </div>
  );
}
